(function () {
  angular.module('MktzapApp.Controllers')
    .controller('CPStatusController', cpSettings);

  cpSettings.$inject = ['StatusService', 'NotificationService', 'FoundationApi', 'CommandProcessorStatusService'];

  function cpSettings (StatusService, NotificationService, FoundationApi, CommandProcessorStatusService) {
    var vmCPStatusCtrl = this;

    vmCPStatusCtrl.command_processors = {};
    vmCPStatusCtrl.status = [];

    vmCPStatusCtrl.loadCommandProcessors = function () {
      CommandProcessorStatusService
        .getAllCommandProcessorStatusByCompany()
        .$promise
        .then(function (data) {
          vmCPStatusCtrl.command_processors = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Algo deu errado ao carregar metadados. Consulte o suporte.');
        });
    };

    vmCPStatusCtrl.removeStatus = function ($row) {
      vmCPStatusCtrl.status.splice($row, 1);
    }

    vmCPStatusCtrl.addCP = function () {
      var obj = { name: null, command_processor: null };
      vmCPStatusCtrl.cp = obj;
      FoundationApi.publish('cpModal', 'open');
    }

    vmCPStatusCtrl.saveCP = function () {
      CommandProcessorStatusService
        .saveCPStatus({
          command_processor: vmCPStatusCtrl.cp
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Status salvo com sucesso.');
          FoundationApi.publish('cpModal', 'close');
          var obj = { name: null, command_processor: null };
          vmCPStatusCtrl.cp = obj;
          vmCPStatusCtrl.loadCommandProcessors();
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao salvar status');
        });
    }

    vmCPStatusCtrl.deleteCP = function (command_processor) {
      CommandProcessorStatusService
        .deleteCPStatus({
          command_processor: command_processor
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Status removido com sucesso.');
          vmCPStatusCtrl.loadCommandProcessors();
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao remover status');
        });
    }

    vmCPStatusCtrl.showStatus = function (command_processor) {
      StatusService.classification_statuses()
        .$promise
        .then(function (data) {
          vmCPStatusCtrl.classificationStatus = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar status');
        });

      CommandProcessorStatusService
        .getCommandProcessorStatus({
          command_processor: command_processor._id
        })
        .$promise
        .then(function (data) {
          vmCPStatusCtrl.command_processor_selected = command_processor;
          vmCPStatusCtrl.status = [];
          angular.forEach(data.status, function (status, key) {
            vmCPStatusCtrl.status[key] = status;
          });
          FoundationApi.publish('statusModal', 'open');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar status');
        });
    }

    vmCPStatusCtrl.saveStatus = function (cp) {
      CommandProcessorStatusService
        .saveCPStatus({
          command_processor: cp,
          status: vmCPStatusCtrl.status
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Status salvos com sucesso.');
          FoundationApi.publish('statusModal', 'close');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao salvar status');
        });
    }

    vmCPStatusCtrl.addNewStatus = function () {
      StatusService.classification_statuses()
        .$promise
        .then(function (data) {
          vmCPStatusCtrl.classificationStatus = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar status');
        });

      if (Object.keys(vmCPStatusCtrl.status).length > 0) {
        $novaLinha = Object.keys(vmCPStatusCtrl.status).length++;
        vmCPStatusCtrl.status[$novaLinha] = { name: null, cp_status: null, mktzap_status_id: null };
      } else {
        vmCPStatusCtrl.status = [];
        var obj = { name: null, cp_status: null, mktzap_status_id: null };
        vmCPStatusCtrl.status.push(obj);
      }
    }

    vmCPStatusCtrl.editCP = function (command_processor) {
      vmCPStatusCtrl.cp = command_processor;
      FoundationApi.publish('cpModal', 'open');
    };

    vmCPStatusCtrl.loadCommandProcessors();
  }
})();
